import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37a8efa4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Envio de documentos", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Foto profissional", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "subtitle-upload" }, " Sua foto deve ter fundo branco ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Foto de um documento de identificação", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Indique o contato de uma pessoa que possa servir de referência", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_CustomField = _resolveComponent("CustomField")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_UploadButton = _resolveComponent("UploadButton")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    class: "pr-registration__content",
    ref: "form",
    model: _ctx.form,
    rules: _ctx.formRules
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [
          _createElementVNode("h1", null, "Cadastro de " + _toDisplayString(_ctx.profession.label), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterPersonalForm, (field, idx) => {
            return (_openBlock(), _createBlock(_component_CustomField, {
              key: idx,
              field: field,
              fieldValue: _ctx.form[field.prop],
              targetRendering: _ctx.profession.target,
              onChange: _ctx.handleFieldChange
            }, null, 8, ["field", "fieldValue", "targetRendering", "onChange"]))
          }), 128))
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                xs: 24,
                sm: 12
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { prop: "pictureProfessional" }, {
                    default: _withCtx(() => [
                      _hoisted_2,
                      _hoisted_3,
                      _createVNode(_component_UploadButton, {
                        limit: 1,
                        model: _ctx.form.pictureProfessional,
                        onUpload: _cache[0] || (_cache[0] = (v) => {_ctx.handleUploadPicture(v, 'pictureProfessional')}),
                        onRemove: _cache[1] || (_cache[1] = (v) => {_ctx.handleRemovePicture('pictureProfessional')})
                      }, null, 8, ["model"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                xs: 24,
                sm: 12
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { prop: "pictureIdentification" }, {
                    default: _withCtx(() => [
                      _hoisted_4,
                      _createVNode(_component_UploadButton, {
                        limit: 1,
                        model: _ctx.form.pictureIdentification,
                        onUpload: _cache[2] || (_cache[2] = (v) => {_ctx.handleUploadPicture(v, 'pictureIdentification')}),
                        onRemove: _cache[3] || (_cache[3] = (v) => {_ctx.handleRemovePicture('pictureIdentification')})
                      }, null, 8, ["model"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _hoisted_5,
      _hoisted_6,
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterFeedbackForm, (field, idx) => {
            return (_openBlock(), _createBlock(_component_CustomField, {
              key: idx,
              field: field,
              fieldValue: _ctx.form[field.prop],
              targetRendering: _ctx.profession.target,
              onChange: _ctx.handleFieldChange
            }, null, 8, ["field", "fieldValue", "targetRendering", "onChange"]))
          }), 128))
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, { style: {"margin-top":"50px"} }, {
        default: _withCtx(() => [
          _createVNode(_component_el_divider)
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, { style: {"text-align":"right"} }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            type: "primary",
            loading: _ctx.loading || _ctx.lockState,
            onClick: _cache[4] || (_cache[4] = () => _ctx.submitForm('form'))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" CONFIRMAR ")
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}